function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.125 3.8125V11.875C3.125 12.2969 3.45312 12.625 3.875 12.625H13.4375C13.7422 12.625 14 12.8828 14 13.1875C14 13.4922 13.7422 13.75 13.4375 13.75H3.875C2.84375 13.75 2 12.9062 2 11.875V3.8125C2 3.50781 2.25781 3.25 2.5625 3.25C2.86719 3.25 3.125 3.50781 3.125 3.8125ZM13.0859 6.46094L9.89844 9.64844C9.6875 9.85938 9.3125 9.85938 9.10156 9.64844L7.25 7.79688L5.21094 9.83594C5 10.0469 4.625 10.0469 4.41406 9.83594C4.20312 9.625 4.20312 9.25 4.41406 9.03906L6.85156 6.60156C7.08594 6.39062 7.4375 6.39062 7.64844 6.60156L9.5 8.45312L12.2891 5.66406C12.5 5.45312 12.875 5.45312 13.0859 5.66406C13.2969 5.875 13.2969 6.25 13.0859 6.46094Z",
  fill: "currentColor"
});

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.f7ebdf88.svg";
export { ForwardRef as ReactComponent };